import { requestReprocessCallsDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const requestReprocessCallsCallable = getCallable(
  requestReprocessCallsDefinition,
);
